module.exports = __webpack_public_path__ + "static/flint-1562add5aa010d5ca8cd5b8891e9a105.mp4";